// import DatePicker from "react-datepicker";
// import { IconButton } from "@material-ui/core";
// import { MdEdit, MdDelete, MdOpenInNew, } from "react-icons/md";
// import authSvgwww from "../assests/www.jpg";
// import { Alpha, Www, getData } from "../components/new"
// import { CountdownCircleTimer } from "react-countdown-circle-timer";
// import KatexMarkdown from "./Markdown";
//import authSvg from "../assests/update.svg";
import React, { Component } from "react";
import Navigation from '../screens/Navigation.jsx';
import Headroom from "react-headroom";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios"
import { removeCokie, removeLocalStorage, setCokie, setLocalStorage, isAuth, isAsignature } from "../helpers/auth";
import { IoIosRemoveCircle, IoMdAlert, IoMdCreate } from "react-icons/io";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
import { MdCreate, MdOutlineCreate } from "react-icons/md";

import ExportToPdf from './boletanotas copy.jsx';



export default class CreateNote extends Component {
  state = {
    category: this.props.match.params.id,
    nombre: "",
    noww: "",
    // scn: "",
    title: "",
    stdaverages: [],
    units: [],
    task: "",
    // fechaexa: new Date(),
    // timexa: "2",
    editing: false,
    isDisabled: "false",
    zz: [],
    newww: [],
    _id: "",
    submit: "",
  };


  getNotes = async () => {
    console.log("res.data[0]");
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/curses/ControllerAll/${this.props.match.params.id}/${isAuth()._id}`
    ).then(res => {
      console.log(res.data[0], "www")
      this.setState({
        zz: res.data[0],
        units: res.data[0].units,
        // isDisabled: "false"
      });
    });
  };

  async componentDidMount() {
    document.title = isAsignature().title
    this.getNotes();
    // this.timeNow()
    // if (this.props.match.params.id && isAuth()) {
    //   //console.log(this.props.match.params.id);
    //   setCokie("id", this.props.match.params.id);
    //   setLocalStorage("id", this.props.match.params.id);
    // } else {
    //   removeCokie("id");
    //   removeLocalStorage("id");
    //   this.props.history.push("/some/Path");
    // }
  }

  // createcurso = async (curseId) => {
  //   const newNote = {
  //     nombre: "this.state.nombre",
  //     contenido: "this.state.contenido",
  //     tarea: "this.state.tarea",
  //     fechaexa: "2022-06-25T16:23:08.196Z",
  //     timexa: "2022-06-25T16:23:08.196Z",
  //   };

  //   await axios.post(`${process.env.REACT_APP_API_URL}/curses`, newNote);
  //   this.getNotes();
  //   this.setState({
  //     nombre: "",
  //     contenido: "",
  //     tarea: "",
  //     fechaexa: "",
  //     timexa: "",
  //   });
  // };
  // upDate = async (curseId) => {
  //   const res = await axios.get(
  //     `${process.env.REACT_APP_API_URL}/curses/` + curseId
  //   );
  //   this.setState({
  //     category: res.data.category,
  //     nombre: res.data.nombre,
  //     contenido: res.data.contenido,
  //     tarea: res.data.tarea,
  //     fechaexa: new Date(res.data.fechaexa),
  //     timexa: res.data.timexa,
  //     editing: true,
  //     _id: res.data._id,
  //     submit: "Actualizar curso",
  //   });
  // };

  // onSubmit = async (e) => {
  //   e.preventDefault();
  //   //console.log(this.state.editing);
  //   if (this.state.editing) {
  //     const updatedNote = {
  //       category: this.state.category,
  //       nombre: this.state.nombre,
  //       contenido: this.state.contenido,
  //       tarea: this.state.tarea,
  //       fechaexa: this.state.fechaexa,
  //       timexa: this.state.timexa,
  //     };
  //     await axios.put(
  //       `${process.env.REACT_APP_API_URL}/curses/` + this.state._id,
  //       updatedNote
  //     );
  //     this.getNotes();
  //     toast.success("Actualizado correctamente");
  //   } else {
  //     const newNote = {
  //       category: this.state.category,
  //       nombre: this.state.nombre,
  //       contenido: this.state.contenido,
  //       tarea: this.state.tarea,
  //       fechaexa: this.state.fechaexa,
  //       timexa: this.state.timexa,
  //     };
  //     console.log(newNote);
  //     await axios.post(`${process.env.REACT_APP_API_URL}/curses`, newNote);
  //     this.getNotes();
  //     this.setState({
  //       nombre: "",
  //       contenido: "",
  //       tarea: "",
  //       fechaexa: "",
  //       timexa: "",
  //     });
  //   }
  // };

  onInputChange = (e) => {
    toast.success(e.target.value)
    this.setState({
      [e.target.name]: e.target.value,
    });
  };


  // timeNow() {
  //   var str = new Date()
  //   let day = str.getDate()
  //   let month = str.getMonth() + 1
  //   let year = str.getFullYear()
  //   let hour = str.getHours()
  //   let mnt = str.getMinutes()
  //   let scn = str.getSeconds()
  //   let format1 = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}T${hour < 10 ? '0' + hour : hour}:${mnt < 10 ? '0' + mnt : mnt}`
  //   this.state({
  //     noww: format1,
  //     scn: scn

  //   })
  // }

  // onChangeDate = (fechaexa) => {
  //   this.setState({ fechaexa });
  // };
  // // deleteNote = async (noteId) => {
  //   const response = window.confirm("Deseas eliminar este curso?");
  //   if (response) {
  //     await axios.delete(`${process.env.REACT_APP_API_URL}/curses/` + noteId);
  //     this.getNotes();
  //   }
  // };

  // createatachTheme = async () => {
  //   this.setState({
  //     isDisabled: "true"
  //   });
  //   // console.log(task, solution, theme, unidad, curse, user, dateb, datee)
  //   // await axios.post(`${process.env.REACT_APP_API_URL}/sections`, { curse: "", idtheme, solution, theme, unidad, curse, user, dateb, datee }).then(res => {
  //   //   console.log(res)
  //   // })
  //   this.getNotes()
  // }

  getStdscalification = async (mencion, ciclo, year, codigo) => {
    console.log(mencion, ciclo, year)
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/users/stdaverages/` + mencion + `/` + ciclo + `/` + year + `/` + codigo
    );
    console.log(res.data);
    console.log("wwwwww");
    this.setState({
      stdaverages: res.data,
    });
  };

  CreateUnit = async () => {
    var data = this.state.zz ? this.state.zz : []
    console.log(data)
    if (data.units === undefined || data.units === null) {
      data.units = []
    }
    data.units.push(
      {
        "title": "this.state.title",
        "detail": "this.state.detail",
        "themes": [],
        "createdAt": new Date(),
        "updatedAt": new Date(),
      }
    )
    this.setState({
      units: data.units,
    });

    console.log(data)
    await axios.put(
      `${process.env.REACT_APP_API_URL}/curses/curse/` + this.props.match.params.id,
      data
    )

  }


  updateUnit = async (event, i) => {
    var data = this.state.zz ? this.state.zz : []
    console.log(event, i)
    data.units[i].title = event
    data.units[i].updatedAt = new Date()
    this.setState({
      units: data.units,
    });
    await axios.put(
      `${process.env.REACT_APP_API_URL}/curses/curse/` + this.props.match.params.id,
      data
    )
  }

  CreateTheme = async (i) => {
    var data = this.state.zz ? this.state.zz : []
    console.log(i)
    data.units[i].themes.push(
      {
        "title": "this.state.title",
        "detail": "this.state.detail",
        "subthemes": [],
        "idtheme": Math.random().toString(36).substring(2, 11).toUpperCase(),
        "createdAt": new Date(),
        "updatedAt": new Date(),
      }
    )
    this.setState({
      units: data.units,
    });
    await axios.put(
      `${process.env.REACT_APP_API_URL}/curses/curse/` + this.props.match.params.id,
      data
    )
  }

  updateTheme = async (event, i, j) => {
    var data = this.state.zz ? this.state.zz : []
    console.log(event, i)
    data.units[i].themes[j].title = event
    data.units[i].themes[j].updatedAt = new Date()
    this.setState({
      units: data.units,
    });
    await axios.put(
      `${process.env.REACT_APP_API_URL}/curses/curse/` + this.props.match.params.id,
      data
    )
  }

  CreateSubTheme = async (i, j) => {
    var data = this.state.zz ? this.state.zz : []
    data.units[i].themes[j].subthemes.push(
      {
        "title": "this.state.title",
        "detail": "this.state.detail",
        "idtheme": Math.random().toString(36).substring(2, 11).toUpperCase(),
        "createdAt": new Date(),
        "updatedAt": new Date(),
      }
    )
    this.setState({
      units: data.units,
    });
    console.log(data)
    await axios.put(
      `${process.env.REACT_APP_API_URL}/curses/curse/` + this.props.match.params.id,
      data
    )
  }

  updateSubTheme = async (event, i, j, k) => {
    var data = this.state.zz ? this.state.zz : []
    console.log(event, i)
    data.units[i].themes[j].subthemes[k].title = event
    data.units[i].themes[j].subthemes[k].updatedAt = new Date()
    this.setState({
      units: data.units,
    });
    await axios.put(
      `${process.env.REACT_APP_API_URL}/curses/curse/` + this.props.match.params.id,
      data
    )
  }



  removeUnit = async (i) => {
    const response = window.confirm("Deseas eliminar este item?");
    if (response) {
      var data = this.state.zz ? this.state.zz : []
      data.units.splice(i, 1);
      console.log(data, "www")
      this.setState({ units: data.units })
      await axios.put(
        `${process.env.REACT_APP_API_URL}/curses/curse/` + this.props.match.params.id,
        data
      )
    }
  }

  removeTheme = async (i, j) => {
    const response = window.confirm("Deseas eliminar este item?");
    if (response) {
      var data = this.state.zz ? this.state.zz : []
      data.units[i].themes.splice(j, 1);
      this.setState({ units: data.units })
      await axios.put(
        `${process.env.REACT_APP_API_URL}/curses/curse/` + this.props.match.params.id,
        data
      )
    }
  }

  removeSubTheme = async (i, j, k) => {
    const response = window.confirm("Deseas eliminar este item?");
    if (response) {
      var data = this.state.zz ? this.state.zz : []
      data.units[i].themes[j].subthemes.splice(k, 1);
      this.setState({ units: data.units })
      await axios.put(
        `${process.env.REACT_APP_API_URL}/curses/curse/` + this.props.match.params.id,
        data
      )
    }
  }



  render() {
    return (
      <>
        <ToastContainer
          closeButton={false}
        />
        <Headroom>
          <Navigation />
        </Headroom>

        <div className="modal fade" id="modalLoginForm" >
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header h1 ffont"> {this.state.title} </div>
              <div className="modal-body">
                <CKEditor editor={ClassicEditor} config={{ language: 'es', }} data={this.state.task} />
              </div>
              <div className="modal-footer p-3">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
              </div>
            </div>
          </div>
        </div>

        <div className="container text-center">
          <div className="bg-light">
            {this.state.zz.length != 0 ? <><h3 className="h1 ffont">{this.state.zz.title}</h3>
              {/* <h5>{this.state.zz._id}</h5> */}
              <h5>Ciclo: {this.state.zz.ciclo} Crédito: {this.state.zz.credito} Carrera: {this.state.zz.mencion}</h5>
            </> : null}
          </div>
          <a className="btn btn-warning m-1" style={{ color: 'white' }} href={'/video/' + this.props.match.params.id} >CONFERENCIA</a>
          <Link className="btn btn-info m-1" style={{ color: 'white' }} to={'/forum/' + this.props.match.params.id} > FORO </Link>
          <Link className="btn btn-info m-1" style={{ color: 'white' }} to={'/archivo/' + this.props.match.params.id} > ARCHIVOS </Link>
          <ExportToPdf data={this.state.zz.credito} cicle={this.state.zz.mencion} yyear={this.state.zz.mencion} />

          <button className='btn btn-info w-100' disabled={this.state.isDisabled === 'true'} onClick={() => {
            this.getStdscalification(this.state.zz.mencion, this.state.zz.ciclo, this.state.zz.year, this.state.zz.codigo)
          }}>Calificar</button>

          <div className="p-1 text-center">
            <div className="row justify-content-center align-items-center">
              {this.state.stdaverages.map((note, index) => (
                <div className="col-md-4 p-1 m-0 text-center" key={index}>
                  <div className="">
                    {note._id}
                    {/* {note.email}
                    {note.name} */}
                    {note.notta[0] ? note.notta[0].nota : ''}
                  </div>
                  <div className="input-group">
                    <input type="text" className="form-control" placeholder="Calificación" onBlur={this.onInputChange} name="title" value={note.notta[0] ? note.notta[0].nota : ''} required />
                    <button className='form-control btn btn-info' disabled={this.state.isDisabled === 'true'} onClick={() => {
                      this.getStdscalification(this.state.newww.mencion, this.state.newww.ciclo, this.state.newww.year, this.state.newww.codigo)
                    }}>Remover</button>
                    {/* <button className='form-control btn btn-warning' disabled={this.state.isDisabled === 'true'} onClick={() => {
                      this.getStdscalification(this.state.newww.mencion, this.state.newww.ciclo, this.state.newww.year, this.state.newww.codigo)
                    }}>Calificar</button> */}
                  </div>

                </div>
              ))}
            </div>
          </div>

          <button className='form-control btn btn-warning' disabled={this.state.isDisabled === 'true'} onClick={() => { this.CreateUnit() }}>Unidad</button>

          <div className="row d-flex justify-content-center border" >
            {this.state.units ? this.state.units.map((note, i) => (
              <div
                className="col-md-6 col-lg-6 border" style={{ padding: '.1em' }}
                key={note._id}
              >
                <div className="bg-light rounded" style={{ padding: '.1em', margin: '.1em' }}>
                  <div className="" contentEditable="true" suppressContentEditableWarning={true} onBlur={(e) => { this.updateUnit(e.target.innerText, i) }}>
                    {note.title}
                  </div>
                  <button className="btn text-center" onClick={() => { this.CreateTheme(i) }}>
                    <IoMdCreate style={{ color: '#3d85bdff', fontSize: '34px' }} />
                  </button>
                  <button className="btn text-center" onClick={() => { this.removeUnit(i) }}>
                    <IoIosRemoveCircle style={{ color: '#bd3d79ff', fontSize: '34px' }} />
                  </button>

                  <div className="row d-flex justify-content-center" style={{ padding: '.1em', margin: '.1em' }}>
                    {note.themes ? note.themes.map((notte, j) => (
                      <div
                        className="col-md-6 col-lg-6" style={{ padding: '.1em' }}
                        key={j}
                      >
                        <div className="bg-warning rounded" style={{ padding: '.3em' }}>
                          <div className="" contentEditable="true" suppressContentEditableWarning={true} onBlur={(e) => { this.updateTheme(e.target.innerText, i, j) }}>
                            {notte.title}
                          </div>
                          {isAuth() && JSON.parse(localStorage.getItem("user")).rol == '2' ? <Link
                            className="btn btn-info w-100"
                            style={{ color: 'white' }}
                            to={{ pathname: '/theme/' + this.state.zz._id + '/' + notte.idtheme, state: { unittitle: note.title, title: notte.title } }}
                          >
                            Actualizar tema
                          </Link> : null}
                          <button className="btn text-center" onClick={() => { this.CreateSubTheme(i, j) }}>
                            <MdCreate style={{ color: '#92bee0ff', fontSize: '34px' }} />
                          </button>
                          <button className="btn text-center" onClick={() => { this.removeTheme(i, j) }}>
                            <IoIosRemoveCircle style={{ color: '#bd3d79ff', fontSize: '34px' }} />
                          </button>

                          <div className="row d-flex justify-content-center border" style={{ padding: '.1em', margin: '.1em' }}>
                            {notte.subthemes ? notte.subthemes.map((nottte, k) => (
                              <div
                                className="col-md-6 col-lg-6 border"
                                key={k}
                              >
                                <div className="" contentEditable="true" suppressContentEditableWarning={true} onBlur={(e) => { this.updateSubTheme(e.target.innerText, i, j, k) }}>
                                  {nottte.title}
                                </div>
                                {isAuth() && JSON.parse(localStorage.getItem("user")).rol == '2' ? <Link
                                  style={{ color: 'white' }}
                                  to={{ pathname: '/theme/' + this.state.zz._id + '/' + nottte.idtheme, state: { title: nottte.title } }}
                                >
                                  Actualizar sesion {this.state.zz._id}
                                </Link> : null}
                                <button className="btn text-center" onClick={() => { this.CreateSubTheme(i, j) }}>
                                  <IoMdAlert style={{ color: '#92bee0ff', fontSize: '34px' }} />
                                </button>
                                <button className="btn text-center" onClick={() => { this.removeSubTheme(i, j, k) }}>
                                  <IoMdAlert style={{ color: '#bd3d79ff', fontSize: '34px' }} />
                                </button>

                              </div>
                            )) : ""}

                          </div>
                        </div>
                      </div>
                    )) : ""}
                  </div>
                </div>
              </div>
            )) : ""}
          </div>

        </div>
      </>
    );
  }
}
